import * as types from 'actions/epg-widget/types';

const initialState = {
  isVisible: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.SHOW:
      return { ...state, isVisible: true };
    case types.HIDE:
      return { ...state, isVisible: false };
    default:
      return state;
  }
};
